import { OnInit, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FilterItem } from '../../models/filter';
var FilterItemComponent = /** @class */ (function () {
    function FilterItemComponent() {
        this.applied = false;
        this.checkBoxControl = new FormControl();
        this.filterToggled = new EventEmitter();
    }
    Object.defineProperty(FilterItemComponent.prototype, "isApplied", {
        set: function (value) {
            this.applied = value;
            this.checkBoxControl.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    FilterItemComponent.prototype.ngOnInit = function () {
        this.checkBoxControl.valueChanges
            .subscribe(this.toggled.bind(this));
    };
    FilterItemComponent.prototype.toggled = function () {
        this.filterToggled.emit({
            code: this.filterItem.code
        });
    };
    return FilterItemComponent;
}());
export { FilterItemComponent };
